export default __webpack_public_path__ + "ab0dd8b25b7560283f3d9760f6b13cdc.png";